import { BaseStampTool, StampStyles } from "./BaseStampTool";

/** A custom PDFTron tool to stamp text. */
class StampTextTool extends BaseStampTool {
    private text: string;

    constructor(viewer: Core.DocumentViewer, width: number, height: number) {
        // Inherit generic annotation create tool
        super(viewer, "StampTextTool", width, height);
    }

    public setText(text: string): void {
        this.text = text;
        this.base64Image = this.build64ImageForText();
    }

    /**
     * Build a base 64 images from the text.
     * The image is twice to required size to provide a better experience when enlarging annotations.
     * @returns a base 64 PNG image.
     */
    private build64ImageForText(): string {
        const canvas = document.createElement("canvas");
        canvas.width = 60;
        canvas.height = 40;

        const canvas2DContext = canvas.getContext("2d");
        canvas2DContext.fillStyle = StampStyles.background;
        canvas2DContext.fillRect(0, 0, canvas.width, canvas.height);
        canvas2DContext.fillStyle = StampStyles.primaryColor;
        canvas2DContext.font = `21pt ${StampStyles.fontFamily}`;
        canvas2DContext.textAlign = "center";
        canvas2DContext.fillText(this.text, 30, 30);

        return canvas.toDataURL("image/png", 1);
    }
}

/** Create the stamp text tool and register it to PDFTron document viewer. */
async function createStampTextTool(documentViewer: Core.DocumentViewer, width: number = 30, height: number = 20): Promise<void> {
    documentViewer.getToolModeMap().StampTextTool = new StampTextTool(documentViewer, width, height);
}

export { createStampTextTool, StampTextTool };
